import {
  I_PayloadGetTickets,
  I_Agents,
} from 'app/pages/NewAccount/CheckTickets/slice/types';
import { BaseXHR } from 'utils/axios';
import { addTicketType } from 'utils/helper';

export const getTicketApi = (payload: I_PayloadGetTickets) =>
  BaseXHR.$get('b2b/v1/ticket/listing', payload);

export const getDataAgentApi = (params?: any) =>
  BaseXHR.$get('b2b/v1/ticket/data-select-agents', params);

export const getDataSelectTicketApi = (payload: I_Agents) =>
  BaseXHR.$get('b2b/v1/ticket/data-select-tickets', payload);

export const cancelTicketApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/ticket/cancel-release-tickets', data);

export const exportExcelApi = (params: any) => {
  const search = new URLSearchParams(params);
  return BaseXHR.$get('b2b/v1/ticket/export-excel?' + search);
};

export const exportHistoryExcelApi = payload => {
  const newParam = new URLSearchParams(payload);
  return BaseXHR.$get('b2b/v1/order/listing-csv?', newParam);
};

export const exportHistoryExcelItemListApi = payload => {
  return BaseXHR.$get('b2b/v1/item/listing-csv', payload);
};

export const exportMyDownLoadOptions = () => {
  return BaseXHR.$get('b2b/v1/my-download/options');
};

export const exportMyDownGetList = payload => {
  const newParam = new URLSearchParams(payload);
  return BaseXHR.$get('b2b/v1/my-download/listing?' + newParam);
};

export const releaseTicketApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/ticket/release-tickets', data);

export const synStatusTicketApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/ticket/sync-status', data);

export const updateCustomerTicketApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/ticket/update-tickets', data);

export const preExchangeTicketApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/checkout/pre-upgrade', data);

export const upgradeTicketApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/checkout/upgrade', addTicketType(data));

export const cancelUpgradeTicketApi = (form: FormData) => {
  return BaseXHR.$post(`b2b/v1/checkout/recover-order-upgrade`, form);
};

export const recoverCancelUpgrade = (data: FormData) =>
  BaseXHR.$post('b2b/v1/checkout/recover-cancel-upgrade', data);

export const getRefundTicketsApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/ticket/get-return-tickets', data);

export const createRefundTicketsApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/ticket/create-return-tickets', data);

export const getOrderReturnTicketsApi = (idHash: string) =>
  BaseXHR.$get(`b2b/v1/ticket/get-order-return-ticket/${idHash}`);

export const approveOrderRefundTicketsApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/ticket/approve-order-return-ticket', data);

export const cancelOrderRefundTicketsApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/ticket/cancel-order-return-ticket', data);

export const getRefundReasonsApi = () =>
  BaseXHR.$get('b2b/v1/ticket/get-return-reasons');
